
import {Observable, of } from 'rxjs';

import {map, flatMap, mergeMap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {AppSettingsService, BaseService, ServiceManager,} from 'iui-iconectiv-lib';
import {UsageResponse} from "../shared/model/usage-response.model";

const ALL_USAGE = '/api/usage/all';
const ADMIN_USAGE = '/api/usage/admin';

@Injectable()
export class UsageDetailsService extends BaseService {

  constructor(serviceManager: ServiceManager,
              private http: HttpClient,
              private appSettings: AppSettingsService,) {

    super(serviceManager);
  }

  getMockUsageSummary(authenticationToken) {
    var res = "{\n" +
      "  \"usagesummary\": [\n" +
      "    {\n" +
      "      \"month\": \"Feb 2018\",\n" +
      "      \"totalQueries\": 100,\n" +
      "      \"totalResults\": 20,\n" +
      "      \"invoiceNumber\": 4611223,\n" +
      "      \"invoiceAmount\": 150,\n" +
      "      \"amountDue\": \"05/05/2018\",\n" +
      "      \"invoiceStatus\": \"paid\",\n" +
      "      \"paidDate\": \"04/05/2018\"\n" +
      "      \n" +
      "    },\n" +
      "    {\n" +
      "      \"month\": \"Jan 2018\",\n" +
      "      \"totalQueries\": 1250,\n" +
      "      \"totalResults\": 1000,\n" +
      "      \"invoiceNumber\": 2221223,\n" +
      "      \"invoiceAmount\": 2500,\n" +
      "      \"amountDue\": \"05/12/2018\",\n" +
      "      \"invoiceStatus\": \"pending\",\n" +
      "      \"paidDate\": \"\"\n" +
      "      \n" +
      "    },\n" +
      "    {\n" +
      "      \"month\": \"Dec 2017\",\n" +
      "      \"totalQueries\": 100,\n" +
      "      \"totalResults\": 20,\n" +
      "      \"invoiceNumber\": 4611223,\n" +
      "      \"invoiceAmount\": 150,\n" +
      "      \"amountDue\": \"05/05/2018\",\n" +
      "      \"invoiceStatus\": \"paid\",\n" +
      "      \"paidDate\": \"04/05/2018\"\n" +
      "      \n" +
      "    }\n" +
      "  ],\n" +
      "  \"messages\": [\n" +
      "    {\n" +
      "      \"code\": \"TNF-6000\",\n" +
      "      \"message\": \"Get usage detail is successful\"\n" +
      "    }\n" +
      "  ],\n" +
      "  \"status\": \"success\"\n" +
      "}\n";

    const r = this.parseToType<UsageResponse>(res);
    return of(r);
  }

  getAdminUsage(authenticationToken): Observable<UsageResponse> {
    return this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
      const url = this.getServer(settings) + ADMIN_USAGE;
      return this.http.get(url, {
        responseType: 'text',
        headers: new HttpHeaders().append('Content-Type', 'application/json').append('Authorization', authenticationToken),
      }).pipe(map(res => {
        const r = this.parseToType<UsageResponse>(res);
        return r;
      }));
    })));
  }

  getAllUsage(authenticationToken: string, accountId: string): Observable<UsageResponse> {
    return this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
      const url = this.getServer(settings) + ALL_USAGE + "/" + accountId;
      return this.http.get(url, {
        responseType: 'text',
        headers: new HttpHeaders().append('Content-Type', 'application/json').append('Authorization', authenticationToken),
      }).pipe(map(res => {
        const r = this.parseToType<UsageResponse>(res);
        return r;
      }));
    })));
  }
}
